// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k5Af","rootMobile":"styles_rootMobile__1bzZT"};